import script from "./ArWechat.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArWechat.vue?vue&type=script&lang=ts&setup=true"

import "./ArWechat.vue?vue&type=style&index=0&id=59bda5f7&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bda5f7"]])

export default __exports__